import { render, staticRenderFns } from "./ShortSellingPage.vue?vue&type=template&id=3dd183f3&scoped=true"
import script from "./ShortSellingPage.vue?vue&type=script&lang=js"
export * from "./ShortSellingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd183f3",
  null
  
)

export default component.exports